import '@fullcalendar/react/dist/vdom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { restClient } from '@uplift/api';
import { TimezoneProvider, sentryInit } from '@uplift/contexts';
import { LocalStorageService } from '@uplift/services';
import { AlertProvider, UpliftThemeProvider, applyGlobalStyles } from '@uplift/ui-v2';
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './app/app';
import { rootStore } from './app/rootStore';
import { environment } from './environments/environment';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

applyGlobalStyles();

if (environment.production) {
  sentryInit(environment.sentryDSN);
}

LocalStorageService.setAppNameSpace(environment.appNameSpace);

restClient.configure({
  apiEndpoint: environment.restApi,
  authClient: rootStore.authClient,
  authStore: rootStore.authStore,
  authRedirectFallback: environment.authUrl,
});

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      networkMode: 'always',
    },
    queries: {
      networkMode: 'always',
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  }
});

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TimezoneProvider>
        <UpliftThemeProvider>
          <AlertProvider>
            <ReactQueryDevtools />
            <App />
          </AlertProvider>
        </UpliftThemeProvider>
      </TimezoneProvider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
